/**
 * CONFIGURACIÓN GLOBAL DEL SITIO
 * Configuración general del sitio web Zero Latency
 */

export const siteConfig = {
  name: "Zero Latency MX",
  description: "Experiencia de realidad virtual inmersiva en México",
  url: "https://zerolatencyvr.com.mx",
  language: "es",
  region: "MX",
};

export const headerConfig = {
  showLogo: true,
  logoScale: 1.3,
  locationButton: {
    text: "MI UBICACIÓN",
    show: true,
  },
  navigation: [
    {
      label: "QUÉ ESPERAR",
      href: "/que-esperar",
    },
    {
      label: "EXPERIENCIAS",
      experienciasDropdown: {
        show: true,
        items: [
          {
            id: "all",
            label: "TODAS LAS EXPERIENCIAS",
            href: "/experiencias",
          },
          {
            id: "threat-lethal",
            label: "THREAT LETHAL",
            href: "/threat-lethal",
          },
          {
            id: "space-marine",
            label: "SPACE MARINE VR",
            href: "/space-marine",
          },
          {
            id: "farcry",
            label: "FAR CRY VR",
            href: "/farcry",
          },
          {
            id: "outbreak",
            label: "OUTBREAK",
            href: "/outbreak",
          },
          {
            id: "singularity",
            label: "SINGULARITY",
            href: "/singularity",
          },
          {
            id: "undead-arena",
            label: "UNDEAD ARENA",
            href: "/undead-arena",
          },
          {
            id: "sol-raiders",
            label: "SOL RAIDERS",
            href: "/sol-raiders",
          },
          {
            id: "engineerium",
            label: "ENGINEERIUM",
            href: "/engineerium",
          },
        ],
      },
    },
    {
      label: "UBICACIONES",
      href: "/ubicaciones",
    },
    {
      label: "FIESTAS Y EVENTOS",
      href: "/eventos",
    },
    {
      label: "PROMOCIONES",
      href: "/promociones",
    },
    {
      label: "LIDERA TU VENUE",
      href: "/",
      icon: "ExternalIcon",
    },
  ],
  ctaButton: {
    text: "¡RESERVA YA!",
    href: "/",
    show: true,
  },
  backgroundColor: "primary",
  sticky: false,
};

export const footerConfig = {
  showLogo: true,
  logoScale: 1.0,
  sections: [
    {
      title: "EXPERIENCIAS",
      links: [
        { label: "OUTBREAK", href: "/outbreak" },
        { label: "SPACE MARINE", href: "/space-marine" },
        { label: "ENGINEERIUM", href: "/engineerium" },
        { label: "FAR CRY VR", href: "/farcry" },
      ],
    },
    {
      title: "INFORMACIÓN",
      links: [
        { label: "QUÉ ESPERAR", href: "/que-esperar" },
        { label: "UBICACIONES", href: "/ubicaciones" },
        { label: "EVENTOS", href: "/eventos" },
        { label: "PROMOCIONES", href: "/promociones" },
      ],
    },
    {
      title: "LEGAL",
      links: [
        { label: "PRIVACIDAD", href: "" },
        { label: "TÉRMINOS", href: "" },
        { label: "COOKIES", href: "" },
        { label: "DIRECTORIO DE LUGARES", href: "" },
      ],
    },
  ],
  copyright: "©2025 Zero Latency MTY. Todos los derechos reservados.",
  backgroundColor: "#000000",
  textColor: "white",
};
